module.exports = __webpack_public_path__ + "img/video.880e05aa.png";